import { useNavigate } from "react-router";
import { StepRail } from "../goal/Native";
import { META_STEPS } from "../goal/steps";

/**
 * The new goal's steps beside its audience and ads steps on an iPad. Once the plan is approved, the plan, the
 * audience and the ads can still be opened from here; the steps before them only show where the goal is.
 */
export function SetupRail({ goalId, step }: { goalId: string; step: number }) {
  const navigate = useNavigate();
  const to = (i: number) => `/goals/${goalId}/${i === 4 ? "plan" : i === 5 ? "audience" : "ads"}`;
  return <StepRail steps={META_STEPS} step={step} canGo={(i) => i >= 4} onGo={(i) => navigate(to(i))} />;
}
